import '@formkit/themes/genesis';
import { fr, en, it, es, de, pl } from '@formkit/i18n';
import { defineFormKitConfig } from '@formkit/vue';
import { genesisIcons } from '@formkit/icons';
import { generateClasses } from '@formkit/themes';
import { isPasswordValid, getPasswordValidationMessage, getPasswordRequirements } from './utils/passwordValidation';

export default defineFormKitConfig({
  locales: { fr, en, it, es, de, pl },
  locale: 'en',
  icons: {
    ...genesisIcons,
  },
  rules: {
    strongPassword: {
      validate: (value) => {
        if (!value) return true; // Let required rule handle empty values
        return isPasswordValid(value);
      },
      message: (context) => {
        // Try to get i18n instance from global context
        if (typeof window !== 'undefined' && window.__NUXT__?.vueApp?.config?.globalProperties?.$i18n) {
          const t = window.__NUXT__.vueApp.config.globalProperties.$i18n.t;
          const requirements = getPasswordRequirements(t);
          return getPasswordValidationMessage(context.value, t, requirements) || t('passwordValidation.messages.required');
        }
        // Fallback to English if i18n not available
        return getPasswordValidationMessage(context.value) || 'Password requirements not met';
      }
    },
    passwordMatch: {
      validate: (value, args) => {
        return value === args[0];
      },
      message: (context) => {
        // Try to get i18n instance for password match message
        if (typeof window !== 'undefined' && window.__NUXT__?.vueApp?.config?.globalProperties?.$i18n) {
          const t = window.__NUXT__.vueApp.config.globalProperties.$i18n.t;
          return t('Passwords do not match') || 'Passwords do not match';
        }
        return 'Passwords do not match';
      }
    }
  },
  config: {
    classes: generateClasses({
      global: {
        // all 
        wrapper: '',
        help: 'text-gray-400 text-xs mt-1',
        inner: '$reset',
      },
      text: {
        inner: '$reset',
        input: '$reset form-input',
      },
      email: {
        inner: '$reset',
        input: '$reset form-input',
      },
      textarea: {
        wrapper: '$reset w-full',
        inner: '$reset',
        input: '$reset form-textarea border border-gray-200 shadow-sm rounded focus',
      },
      password: {
        inner: '$reset',
        input: '$reset form-input',
      },
      submit: {
        inner: '$reset',
        input: '$reset btn btn-primary',
      },
      checkbox: {
        'icon': '$reset hidden',
        input: '$reset form-checkbox',
        label: '$reset text-sm pl-2',
      },
      select: {
        inner: '$reset',
        'icon': '$reset hidden',
        input: '$reset form-select',
      },
    }),
  },
});
